import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class surveyReviewsTableCtrl implements IController {

  type: any;
  infiniteScroll: any;

  /* @ngInject */
  constructor() {
  }

  getFieldFlex(question) {
    if (_.get(question, 'type') === 'STRING') {
      return 20;
    }
    return undefined;
  }

}

angular
  .module('bringoz.admin.survey')
  .component('surveyReviewsTable', {
    bindings: {
      type: '<',
      infiniteScroll: '<'
    },
    template: require('./survey-reviews-table.html').default,
    controller: surveyReviewsTableCtrl
  });
